import styled, { css } from 'styled-components';
import { listViewSizing } from '@/app/components/searchPageStyled.ts';
import { viewSwitchTransition } from '@/app/components/search/styles/mixins.ts';
import { getListWidth } from '@/app/components/search/components/SearchPageContainer/ListContainer/utils.ts';

export const RootListContainer = styled.div<{ hasSidebar?: boolean }>`
  display: flex;
  flex-direction: ${({ hasSidebar }) => (hasSidebar ? 'row' : 'column')};
  width: 100%;
  ${listViewSizing};
  min-width: 0;
`;

export const RootMapContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

/**
 * The desktop root for both list and map. One element for both views keeps the list mounted on a switch,
 * so the ads already rendered in it stay.
 */
export const RootDesktopContainer = styled.div<{ $isMap: boolean; $evolutionResultsOnlyEnabled?: boolean }>`
  display: flex;
  width: 100%;
  ${viewSwitchTransition(['width', 'margin-left', 'padding-left', 'padding-right'])};
  ${({ $isMap, $evolutionResultsOnlyEnabled }) =>
    $isMap
      ? css`
          flex-direction: column;
          ${getListWidth(false, $evolutionResultsOnlyEnabled)};
        `
      : css`
          flex-direction: ${$evolutionResultsOnlyEnabled ? 'column' : 'row'};
          ${listViewSizing};
          min-width: 0;
        `}
`;

export const HybridContainer = styled.div<{ isCurated?: boolean }>`
  display: flex;
  width: 100%;

  &.list-layout {
    ${listViewSizing};
  }
`;
